import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TechmoreSharedModule } from '@techmore/share';
import { TranslateModule } from '@ngx-translate/core';
import { TemplateControllerComponent } from './component/template-controller/template-controller.component';
import { MenuComponent } from './component/menu/menu.component';
import { Banner01Component } from './component/banner-01/banner-01.component';
import { ShareModule } from 'src/app/share/share.module';
import { FormsModule } from '@angular/forms';
import { MemberLogingButtonComponent } from './component/member-loging-button/member-loging-button.component';
import { MemberPreferenceModalComponent } from './component/member-preference-modal/member-preference-modal.component';
import { GlobalModule } from '@techmore/global';
import { FooterControlerComponent } from './component/footer-controler/footer-controler.component';

/**
 * 首頁外框特徵模組
 * 只有首頁模板高度重複使用的功能能放在這裡
 */
@NgModule({
  declarations: [
    TemplateControllerComponent,
    MenuComponent,
    Banner01Component,
    TemplateControllerComponent,
    MemberLogingButtonComponent,
    MemberPreferenceModalComponent,
    FooterControlerComponent,
  ],
  exports: [
    TemplateControllerComponent,
    MenuComponent,
    Banner01Component,
    TemplateControllerComponent,
    MemberLogingButtonComponent,
    MemberPreferenceModalComponent,
    FooterControlerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ShareModule,
    TechmoreSharedModule,
    FormsModule,
    GlobalModule,
    TranslateModule.forChild(),
  ]
})
export class TemplateShareModule { }
